@if (density() === 'compact') {
  <button
    [matMenuTriggerFor]="progressMenu"
    [disabled]="readonly()"
    [matTooltip]="'project-tasks.list.column-headers.progress' | translate"
    [attr.aria-label]="
      ('project-tasks.list.column-headers.progress' | translate) + ': ' + formatPercent(selectedProgress())
    "
    type="button"
    class="task-progress-select-trigger proffeo-ui-focus-ring"
  >
    {{ formatPercent(selectedProgress()) }}
  </button>

  <mat-menu
    #progressMenu="matMenu"
    xPosition="before"
  >
    <!-- Clicks inside keep the panel open so the value can be adjusted more than once. -->
    <div
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      class="task-progress-select-panel"
    >
      <proffeo-ui-slider
        (valueChange)="onProgressChange($event)"
        [value]="selectedProgress()"
        [displayWith]="formatPercent"
        class="w-full"
      />
    </div>
  </mat-menu>
} @else {
  <proffeo-ui-slider
    (valueChange)="onProgressChange($event)"
    [value]="selectedProgress()"
    [readonly]="readonly()"
    [displayWith]="formatPercent"
    class="w-24"
  />
}
